import React from 'react';
import Layout from '@/components/Layout';
import { RequirementsCatalogList, RequirementsCatalogDetail } from '@/components/RequirementsCatalog';

export const RequirementsCatalogListPage = ({ user, onLogout }) => {
  return (
    <Layout user={user} onLogout={onLogout}>
      <RequirementsCatalogList />
    </Layout>
  );
};

export const RequirementsCatalogDetailPage = ({ user, onLogout }) => {
  return (
    <Layout user={user} onLogout={onLogout}>
      <RequirementsCatalogDetail />
    </Layout>
  );
};
